import Head from 'next/head';
import Link from 'next/link';

import { SellForexHelpSEO } from '@/utils/constants/MetaData';

const General = () => {
  return (
    <>
      <Head>
        <title>{SellForexHelpSEO.metaTitle}</title>
        <meta name="description" content={SellForexHelpSEO.metaDescription} />
        <meta
          property="og:description"
          content={SellForexHelpSEO.metaOGDescription}
        />
        <link
          rel="canonical"
          href="https://www.muthootfincorpone.com/help/forex/sell-forex/"
        />
      </Head>
      <main className="repayment singleFlow--lightBlue pledge setting">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link href="/help">Forex Help</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Sell Forex Currency
              </li>
            </ol>
          </nav>
          <div className="loanDetails__card loanCard accordion setting-faq-accordion">
            <h1 className="loanCard__title text--bold text--black">
              Sell Forex Currency
            </h1>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingOne"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="false"
                aria-controls="collapseOne"
              >
                <h2 className="text--black text--semi title">
                  How can I sell my left-over Forex cash at Muthoot FinCorp ONE?
                </h2>
              </div>
              <div
                id="collapseOne"
                className="collapse"
                aria-labelledby="headingOne"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    At Muthoot FinCorp ONE you can choose the currency online
                    you want to sell and then book an appointment online to
                    visit the nearest Muthoot FinCorp Forex branch. Submit your
                    documents at the branch, at the appointed time and get money
                    instantly transferred to your bank account.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingTwo"
                data-toggle="collapse"
                data-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                <p className="text--black text--semi title">
                  Can I also sell foreign exchange coins?
                </p>
              </div>
              <div
                id="collapseTwo"
                className="collapse"
                aria-labelledby="headingTwo"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Yes, Muthoot FinCorp branch also accepts coins along with
                    currency notes.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingThree"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                <p className="text--black text--semi title">
                  Can I exchange Forex currency at Muthoot FinCorp branch even
                  though I have not purchased the same from you?
                </p>
              </div>
              <div
                id="collapseThree"
                className="collapse"
                aria-labelledby="headingThree"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Yes, at Muthoot FinCorp branch, we accept Forex currency
                    even if you have not purchased from us.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingFour"
                data-toggle="collapse"
                data-target="#collapseFour"
                aria-expanded="false"
                aria-controls="collapseFour"
              >
                <p className="text--black text--semi title">
                  Can I exchange torn or soiled Forex notes at Muthoot FinCorp
                  branch?
                </p>
              </div>
              <div
                id="collapseFour"
                className="collapse"
                aria-labelledby="headingFour"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    At Muthoot FinCorp branch we do not accept torn or soiled
                    notes
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingFive"
                data-toggle="collapse"
                data-target="#collapseFive"
                aria-expanded="false"
                aria-controls="collapseFive"
              >
                <p className="text--black text--semi title">
                  What is the documentation required for selling Forex to
                  Muthoot FinCorp?
                </p>
              </div>
              <div
                id="collapseFive"
                className="collapse"
                aria-labelledby="headingFive"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    If you are a foreign resident, we would need a copy of your
                    passport along with VISA and if you are an Indian resident,
                    we would require your KYC documents (Aadhar Card/Driving
                    Licence/Pan Card/Passport/Voter ID). Please note that VISA
                    is mandatory in both cases.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default General;
